module.exports = "<jhi-page-ribbon></jhi-page-ribbon> <div> <router-outlet name=\"navbar\"></router-outlet> </div> <div class=\"container-fluid\"> <div class=\"card jh-card\"> <router-outlet></router-outlet> <router-outlet name=\"popup\"></router-outlet> </div> <jhi-footer></jhi-footer> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/layouts/main/main.component.html
// module id = 438
// module chunks = 0